import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { ActiveCall } from 'app/models/dto/call.model';
import { CallDisplayComponent } from 'ng2-app/call-display/call-display/call-display.component';
import { environment } from 'environments/environment';
import { SoftphoneService } from 'app/services/call/softphone.service';
import { DirectoryListItem } from 'app/models/dto/directory-list-item.model';
import { Store } from '@ngxs/store';
import { PushCallAlert } from 'app/store/call/call.actions';
import { catchError, map, takeUntil, tap } from 'rxjs/operators';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { CountryDataState } from 'ng2-app/store/country/country-data.state';
import { LocaleSettingService } from 'app/services/i18n/locale-setting.service';

@Component({
  selector: 'app-softphone-menu',
  templateUrl: './softphone-menu.component.html',
  styleUrls: ['./softphone-menu.component.scss'],
  standalone: false
})
export class SoftphoneMenuComponent implements OnInit, OnDestroy {

  @Input() callDisplay: CallDisplayComponent;
  @Input() call: ActiveCall;
  @Input() alreadyTwoCalls: boolean;
  @Input() callStateIsProcessing: boolean;
  @Input() callIsOnHold: boolean;
  @Output() placeCallOnHold = new EventEmitter();
  @Output() startSecondCall = new EventEmitter();
  @Output() transferCall = new EventEmitter();
  canViewNewTransfer$: Observable<boolean>;
  lendioDirectory$: Observable<DirectoryListItem[]>;
  lendioDirectory: DirectoryListItem[];
  destroyed$ = new Subject<boolean>();
  lendioDirectoryIsProcessing = false;
  phoneCountryCode: number | null = null;
  navPath = '';
  phoneNumberInput = '';
  twilioNumber = '';
  lenderUserLink = environment.API_URL + '/phone/download-lender-user-directory';
  callQueueLink = environment.API_URL + '/phone/download-call-queue-directory';
  addCallModel: any = {
    phone: {
      phone: null,
      countryCode: this.localeSettingService.getDefaultLocalePhoneCode()
    }
  };
  addCallForm = new UntypedFormGroup({});
  addCallOptions: FormlyFormOptions = {};
  addCallFields: FormlyFieldConfig[] = [
    {
      key: 'phone',
      type: 'intl-phone',
      templateOptions: {
        label: 'Phone',
        attributes: {
          'data-cy': 'add-call-direct-phone-input'
        }
      }
    }
  ];
  transferCallModel: any = {
    phone: {
      phone: null,
      countryCode: this.localeSettingService.getDefaultLocalePhoneCode()
    }
  };
  transferCallForm = new UntypedFormGroup({});
  transferCallOptions: FormlyFormOptions = {};
  transferCallFields: FormlyFieldConfig[] = [
    {
      key: 'phone',
      type: 'intl-phone',
      templateOptions: {
        label: 'Phone',
        attributes: {
          'data-cy': 'transfer-call-direct-phone-input'
        }
      }
    }
  ];

  constructor(
    private softphoneService: SoftphoneService,
    private store: Store,
    private localeSettingService: LocaleSettingService
  ) {
    this.lenderUserLink = environment.API_URL + '/phone/download-lender-user-directory';
    this.callQueueLink = environment.API_URL + '/phone/download-call-queue-directory';
  }

  ngOnInit() {}

  coldTransfer(callInfo: object): void {
    this.transferCall.emit(callInfo);
  }

  warmTransfer(callInfo: object): void {
    this.startSecondCall.emit(callInfo);
  }

  handleHoldCall() {
    if (!!this.call.callState) {
      this.placeCallOnHold.emit(this.call.callState === 'on hold' ? false : true);
    }
  }

  navPush(path) {
    this.navPath += (this.navPath ? '.' : '') + path;
  }

  getLendioDirectory() {
    this.lendioDirectory$ = this.softphoneService.getLendioDirectory();
    this.lendioDirectoryIsProcessing = true;
    this.lendioDirectory$.pipe(
      catchError(err => {
      const errorText = err.message ?? 'There was an error retrieving the Lendio Directory';
      this.store.dispatch(new PushCallAlert('error', errorText));
      this.lendioDirectoryIsProcessing = false;
      return of();
    }), tap(directoryData => {
      this.lendioDirectory = directoryData;
      this.lendioDirectoryIsProcessing = false;
    }),
    takeUntil(this.destroyed$)).subscribe();
  }

  navPop() {
    this.navPath = this.navPath.split('.').slice(0, -1).join('.');
  }

  navReset() {
    setTimeout(() => {
      this.navPath = '';
    }, 100);
  }

  setPhoneCountryCode(phoneCountryCode: string) {
    const countryCodeIdValue = phoneCountryCode ? phoneCountryCode : '2';
    this.store.select(CountryDataState.countryFromPhoneCountyCodeId)
      .pipe(
        takeUntil(this.destroyed$),
        map(filterFn => filterFn(countryCodeIdValue))
      )
      .subscribe((countryData) => {
        if (countryData) {
          this.phoneCountryCode = countryData.phoneCountryCode?.countryCode || null;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
